
import { processedUrl } from '@padlet/vivaldi-client'
import { Component, Emit, Prop, Vue } from 'bits/vue'

@Component({})
export default class ProcessedImage extends Vue {
  @Prop({ type: String }) src!: string
  @Prop({ type: Number }) width!: number
  @Prop({ type: Number }) height!: number
  @Prop({ type: Object }) transforms!: { [key: string]: string | number }

  get processedSrc() {
    // For relative urls in development
    if (this.src.startsWith('/')) return this.src

    const purl = processedUrl(this.src, this.transforms)
    return purl
  }

  @Emit('error')
  handleError(error) {
    return error
  }
}
